import React, { useState } from "react";
import BirthProfileFields from "./BirthProfileFields";
import { Card, SectionHeading, PrimaryButton, ErrorBanner } from "./ui";
import { createChart } from "../api/kundliApi";
import { usePremiumGate } from "../hooks/usePremiumGate";

const empty = { name: "", gender: "male", dob: "", tob: "", place: "", timezone: 5.5 };

/**
 * API #5 — POST /api/kundli/chart/
 * Gated behind payment: the chart is only generated after the user
 * completes a Razorpay payment for the amount the backend returns.
 */
export default function BirthChartForm() {
  const [form, setForm] = useState(empty);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { runGated, gateModal, priceError } = usePremiumGate("chart", "Janam Kundli Birth Chart");

  const performGenerate = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await createChart(form);
      setResult(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    runGated(performGenerate);
  };

  return (
    <Card>
      <SectionHeading
        eyebrow="Janam Kundli"
        title="Birth Chart"
        subtitle="Generate a precise Vedic birth chart from an exact date, time and place of birth."
      />

      <form onSubmit={handleSubmit}>
        <BirthProfileFields value={form} onChange={setForm} />

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <PrimaryButton type="submit" loading={loading} loadingText="Generating…">
            ✦ Generate Kundli
          </PrimaryButton>
        </div>
      </form>

      <ErrorBanner message={error || priceError} />

      {result && (
        <div style={styles.result}>
          <p style={styles.resultText}>
            <strong>{result.birth_profile?.name}</strong>'s Janam Kundli has been generated.
          </p>
          {result.pdf_url && (
            <a href={result.pdf_url} target="_blank" rel="noopener noreferrer" style={styles.pdfBtn}>
              📄 Download PDF
            </a>
          )}
        </div>
      )}

      {gateModal}
    </Card>
  );
}

const styles = {
  result: {
    marginTop: 22, background: "var(--paper-2)", padding: "20px 18px", borderRadius: "var(--radius)",
    textAlign: "center", animation: "km-fade-up 0.35s var(--ease)",
  },
  resultText: { margin: 0, fontSize: 14.5, color: "var(--ink)" },
  pdfBtn: {
    display: "inline-block", marginTop: 14, padding: "10px 22px", background: "var(--success)",
    color: "#fff", borderRadius: 999, textDecoration: "none", fontWeight: 700, fontSize: 13.5,
  },
};
